define('util/initializeModelReferenceField',[
    'lib/lodash4',
    'lib/knockout'
], function (_, ko) {

    'use strict';

    var defaultComparator = function (modelReference, currentReference) {
        return ko.unwrap(modelReference.selfUri) === ko.unwrap(currentReference.selfUri);
    };

    /**
     * This will replace a property on a model with a matching value from the reference list. This allows Knockout
     * bindings like select to use full models as their data backing instead of strings and work properly despite their
     * lack of a comparator callback.
     *
     * This will handle edge cases... like if no reference property is found, or the current reference is not valid.
     *
     * @param model - The parent entity model to introspect.
     * @param propertyName - The name of the parent entity model property that will reference another entity.
     * @param validValueList - The list of possible valid reference values.
     * @param comparator - A comparator function (OPTIONAL).
     * @param ignoreException - In certain cases we'd like to ignore an exception and continue to populate a
     * a model property with the provided defaults to take an advantage of ko's validation handlers
     */
    var initializeReference = function (model, propertyName, validValueList, comparator, ignoreException) {
        comparator = comparator ? comparator : defaultComparator;

        var unwrappedValidValueList = ko.unwrap(validValueList);
        if (unwrappedValidValueList.length < 1) {
            //provide localized message
            var referenceError = ko.i18n.renderString('property.reference.error.default', { propertyName: propertyName });
            if (!ignoreException)
            {
                throw new Error(referenceError);
            }
        }

        // If the reference property is not defined, initialize it to the first valid value in the list.
        if (!model[propertyName]) {
            model[propertyName] = ko.observable(unwrappedValidValueList[0]);
            return;
        }

        // Look for a valid value that matches the current reference.
        var value = _.find(unwrappedValidValueList, function (validValue) {
            var modelProperty = ko.unwrap(model[propertyName]);
            return comparator(modelProperty, validValue);
        });

        // If a matching item is found, use that.
        if (value) {
            model[propertyName](value);
            return;
        }
        // Just use the first item in the list. The current reference is invalid for some reason.
        model[propertyName](unwrappedValidValueList[0]);
    };

    return  initializeReference;

});
